// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  TalkTopic,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  villageId: __t.u64().name("village_id"),
  slot: __t.u8(),
  role: __t.u8(),
  building: __t.u8(),
  deal: __t.u8(),
  frame: __t.u16(),
  name: __t.string(),
  epithet: __t.string(),
  goods: __t.string(),
  price: __t.u32(),
  hireClass: __t.u8().name("hire_class"),
  tradeDef: __t.u16().name("trade_def"),
  tradeTier: __t.u8().name("trade_tier"),
  dealPitch: __t.string().name("deal_pitch"),
  dealYes: __t.string().name("deal_yes"),
  dealNo: __t.string().name("deal_no"),
  farewell: __t.string(),
  greeting: __t.string(),
  get topics() {
    return __t.array(TalkTopic);
  },
  secretTeaser: __t.string().name("secret_teaser"),
  secretAbout: __t.string().name("secret_about"),
  pours: __t.bool(),
  state: __t.u8(),
  joinedHero: __t.u64().name("joined_hero"),
});
